function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  id: "canvas_background",
  d: "M-1-1h80v80H-1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  fill: "#fff",
  id: "svg_1",
  d: "M79 34.429H45.571V1H34.43v33.429H1V45.57h33.429V79H45.57V45.571H79z"
}));

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCiA8Zz4KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgPHJlY3QgZmlsbD0ibm9uZSIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjgwIiB3aWR0aD0iODAiIHk9Ii0xIiB4PSItMSIvPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxwb2x5Z29uIHN0cm9rZT0iI2ZmZiIgZmlsbD0iI2ZmZiIgaWQ9InN2Z18xIiBwb2ludHM9Ijc5LDM0LjQyODU2OTc5MzcwMTE3IDQ1LjU3MTQzMDIwNjI5ODgzLDM0LjQyODU2OTc5MzcwMTE3IDQ1LjU3MTQzMDIwNjI5ODgzLDEuMDAwMDAyNTQwNTUxNTc3MSAzNC40Mjg1Njk3OTM3MDExNywxLjAwMDAwMjU0MDU1MTU3NzEgMzQuNDI4NTY5NzkzNzAxMTcsMzQuNDI4NTY5NzkzNzAxMTcgMS4wMDAwMDA1OTYwNDY0NDc4LDM0LjQyODU2OTc5MzcwMTE3IDEuMDAwMDAwNTk2MDQ2NDQ3OCw0NS41NzE0MzAyMDYyOTg4MyAzNC40Mjg1Njk3OTM3MDExNyw0NS41NzE0MzAyMDYyOTg4MyAzNC40Mjg1Njk3OTM3MDExNyw3OSA0NS41NzE0MzAyMDYyOTg4Myw3OSA0NS41NzE0MzAyMDYyOTg4Myw0NS41NzE0MzAyMDYyOTg4MyA3OSw0NS41NzE0MzAyMDYyOTg4MyAiLz4KIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };